<template>
    <a :href="presentation.detail_uri" class="presentation" :style="blockStyles" @mouseover="hover = true" @mouseleave="hover = false">
        <div :style="{ backgroundColor : presentation.background_color }" class="px-3 py-3">
            <div ref="title" :style="{ height: titleHeight }" class="overflow-hidden">
                <div class="mb-1"><strong>{{ presentation.title[_locale] }}</strong></div>
                <small v-if="presentation.speakers.length">{{ speakerNames }}</small>
            </div>
            <div class="meta d-flex justify-content-between align-items-center" ref="time" v-if="presentation.duration >= 25 || hover">
                <a :href="presentation.calendar_link" @click.prevent="addToCalendar(presentation.calendar_link)" class="calendar-link">
                    <i class="fa fa-calendar-plus-o" style="font-size: 30px;"></i>
                </a>
                <span class="small">{{ $dayjs.utc(presentation.starts_at).tz('Europe/Amsterdam').format('HH:mm') }} - {{ $dayjs.utc(presentation.ends_at).tz('Europe/Amsterdam').format('HH:mm') }}</span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: ['presentation', 'mobile', 'hour-height', 'start-and-end-time'],
    data() {
        return {
            hoverHeight: 300,
            initHeight: null,
            compressedTitleHeight: null,
            hover: false,
            titleSpacing : 70,
        }
    },
    methods: {
        setHeights() {
            this.initHeight = this.presentation.duration / 60 * this.hourHeight;

            Vue.nextTick(() => {
                this.hoverHeight = Math.max(jQuery(this.$refs.title).height() + this.titleSpacing, this.initHeight);

                if (this.hoverHeight > this.initHeight) {
                    let newTitleHeight = jQuery(this.$refs.title).height();
                    let newHeight = newTitleHeight + this.titleSpacing;

                    do {
                        newTitleHeight--;
                        newHeight = newTitleHeight + this.titleSpacing;
                    } while (newHeight > this.initHeight);

                    this.compressedTitleHeight = this.presentation.duration < 25 ? 40 : newTitleHeight + 5;
                }
            })
        },
        addToCalendar(link) {
            if (confirm(this.__('Please note: check whether the correct time has been placed in your agenda. It sometimes happens that settings in Outlook cause a 1 hour time difference.'))) {
                window.location = link;
            }
        }
    },
    computed: {
        blockStyles() {
           if (this.mobile) {
               return null;
           }

           return { height : this.blockHeight + 'px', top : this.topDistance, zIndex : this.zIndex}
        },
        speakerNames() {
            let speakerNames = [];

            this.presentation.speakers.forEach(speaker => {
               speakerNames.push(speaker.name);
            });

            return speakerNames.join(', ');
        },
        topDistance() {
            if (!this.startAndEndTime) {
                return;
            }

            let startsAt = this.$dayjs(this.presentation.starts_at);
            let firstTime = startsAt.set('hour', this.startAndEndTime.start.hour()).set('minute', this.startAndEndTime.start.minute() < 30 ? 0 : 30);

            return startsAt.diff(firstTime, 'minute') / 60 * this.hourHeight + 'px';
        },
        blockHeight() {
            if (this.hover) {
                return this.hoverHeight;
            } else {
                return this.initHeight;
            }
        },
        zIndex() {
            if (this.hover) {
                return 9;
            } else {
                return 1;
            }
        },
        titleHeight() {
            if (this.hover) {
                return null;
            } else {
                return this.compressedTitleHeight +'px';
            }
        }
    },
    mounted() {
        if (!this.mobile) {
            this.setHeights();
        }
    },
}
</script>
